import React from 'react';
import { Box, Text, VStack, Heading, Button, Image, Container, Flex } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ArrowBackIcon, DownloadIcon } from '@chakra-ui/icons';
import { ChevronRightIcon } from '@chakra-ui/icons';
import Navbar from '../Components/Navbar';
import { useNavigate } from 'react-router-dom';
import NavigationButtons from '../Components/NavigationButtons'; // Import the NavigationButtons component

function ResumeResources() {
  const navigate = useNavigate(); // Initialize the navigate function

  const handleNext = () => {
    navigate('/resume-resource-page-2'); // Navigate to the next step
  };

  const handleBack = () => {
    navigate('/resources'); // Navigate to the previous step
  }


  return (
    <Box>
      {/* Header */}
      <Box bg="#00D29D" w="100%" h="8vh" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="16px" fontWeight="semibold">Resources</Text>
      </Box>

      {/* Main Content */}
      <Container bg="white" p={6} maxW="container.md" fontFamily="Raleway">
        <VStack spacing={6} align="stretch">
          <Heading size="lg" color="#13BD95" fontFamily="Raleway">
            Crafting a Standout Resume
          </Heading>

          <Heading size="md" fontFamily="Raleway">Resume Writing</Heading>
          <Text fontFamily="Raleway">
            When applying for any job, having a polished and professional resume is essential. Your 
            resume is often the first thing seen by a potential employer, so it's crucial to make it 
            stand out. To ensure your resume catches the eye of hiring managers, highlighting your 
            relevant experience, skills, and accomplishments in the professional world.
          </Text>

          <Heading size="md" fontFamily="Raleway">Getting Started</Heading>
          
          <Button
            leftIcon={<DownloadIcon boxSize={10} />} // Make icon larger
            as = 'a'
            href = 'https://www.mccombs.utexas.edu/wp-content/uploads/2024/06/tMPA_Application_Resume_Template.docx'
            download="JumpFinance_Resume_Template.pdf"
            variant="outline"
            color="#13BD95"
            borderColor="#13BD95"
            size="lg"
            width="100%" // Make it full width
            display="flex"
            justifyContent="flex-start" // Align text to the left
            p={10}
            fontSize="lg" // Make text bigger
          >
            <VStack align="start" spacing={0} fontStyle="italic" color="#6E6E6E">
              <Text fontSize="15px">Downloadable</Text>
              <Text fontSize="15px">JumpFinance Resume</Text>
              <Text fontSize="15px">Template</Text>
            </VStack>
          </Button>
          

          <Text>
            An effective resume template that has helped countless students secure their dream offers is 
            the University McCombs School of Business' official resume template. We highly 
            recommend using this template to create your resume.
          </Text>

          {/* <Text>
            Before we delve into the details, please take a moment to skim the template, shown in the 
            image below.
          </Text> */}
        </VStack>
        {/* <Flex align="center" justify="flex-end" cursor="pointer" onClick={handleNext}>
          <Text style={{ font: 'Inter', fontSize: '16px' }}>Next</Text>
          <ChevronRightIcon w={12} h={12} color="#10b981" />
        </Flex> */}
      </Container>
      <Box marginTop="50px">
        <Navbar/>
      </Box>
      
      {/* Next Button */}
      <NavigationButtons onNext={handleNext} onBack={handleBack} />
      

    </Box>
    
  );
}

export default ResumeResources;
